module.exports = __webpack_public_path__ + "img/鄙视.ebe66c9a.gif";